<template>
    <v-container>
        <h1 class="titulo mb-3">Cadastro de Produtos</h1>
        <v-card class="card">
            <v-card-text>
                <v-form ref="formProduto" @submit.prevent="sendProduto">
                    <v-row>
                        <v-col cols="3">
                            <v-text-field
                                    label="ID do Produto:"
                                    placeholder="Informe o ID do Produto"
                                    class="required"
                                    outlined
                                    :rules="[$rules.required]"
                                    v-input-filter="[$filters.numeric]"
                                    maxlength="20"
                                    v-model="form_data.id_produto"
                            />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field
                                    label="Código do Produto:"
                                    placeholder="Informe o Código do Produto"
                                    class="required"
                                    outlined
                                    :rules="[$rules.required]"
                                    v-input-filter="[$filters.numeric]"
                                    maxlength="20"
                                    v-model="form_data.codigo_produto"
                            />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field
                                    label="Nome do Produto:"
                                    placeholder="Informe o Nome do Produto"
                                    class="required"
                                    outlined
                                    :rules="[$rules.required]"
                                    maxlength="300"
                                    v-model="form_data.nome_produto"
                            />
                        </v-col>
                        <v-col cols="3">
                            <DynamicSelect
                                    label="Marcas:"
                                    id="FlavorSelect"
                                    v-model="form_data.id_flavor"
                                    placeholder="Selecione a Marca"
                                    endpoint="/dynamic-selects/flavors/id"
                                    :multiple="false"
                                    item-text="label"
                                    item-value="id"
                            />
                        </v-col>
                        <v-col cols="3">
                            <DynamicSelect
                                    label="Empresa: *"
                                    id="EmpresaSelect"
                                    v-model="form_data.id_empresa_newcon"
                                    placeholder="Selecione a Empresa"
                                    endpoint="/dynamic-selects/empresas/id"
                                    :multiple="false"
                                    :rules="[$rules.required]"
                                    item-text="label"
                                    item-value="id"
                            />
                        </v-col>
                        <v-col cols="3">
                            <DynamicSelect
                                    label="Modalidade: *"
                                    placeholder="Selecione a Modalidade"
                                    endpoint="/dynamic-selects/modalidades/id"
                                    :multiple="false"
                                    item-text="label"
                                    item-value="id"
                                    v-model="form_data.id_modalidade"
                                    :rules="[$rules.required]"
                                    outlined
                            />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field
                                    label="Unidade de Negócio:"
                                    placeholder="Informe a Unidade de Negócio"
                                    outlined
                                    v-input-filter="[$filters.numeric]"
                                    v-model="form_data.id_unidade_negocio"
                            />
                        </v-col>
                    </v-row>
                    <v-row class="justify-end">
                        <v-btn class="transition mr-4" color="secondary" type="reset" @click="resetForm">Limpar</v-btn>
                        <v-btn class="transition mr-4" color="primary" type="submit">Salvar</v-btn>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
  import { get } from 'lodash'
  import { AlertTypes } from '../../../plugins/alerts_types'
  import { notification, alert } from '../../../plugins/helpers'

  export default {
    name: 'FormularioCadastroProdutos',
    props: {
      produtoEdicao: {
        type: Object,
        default: null
      }
    },
    data () {
      return {
        form_data: {
          id_cadastro: null,
          id_produto: null,
          codigo_produto: null,
          nome_produto: null,
          id_flavor: null,
          id_empresa_newcon: null,
          id_modalidade: null,
          id_unidade_negocio: null,
          produtosExistentes: []
        }
      }
    },
    computed: {
      produtoParaEditar: {
        get () {
          return this.produtoEdicao
        },
        set (val) {
          this.$emit('input', val)
        }
      }
    },
    watch: {
      produtoParaEditar (produto) {
        if (produto && produto.codigo_produto) {
          window.scrollTo({ top: 0, behavior: 'smooth' })
          this.form_data = {
            id_cadastro: produto.id_cadastro,
            id_produto: produto.id_produto,
            codigo_produto: produto.codigo_produto,
            nome_produto: produto.nome_produto,
            id_flavor: produto.id_flavor || null,
            id_empresa_newcon: produto.id_empresa_newcon,
            id_modalidade: produto.id_modalidade,
            id_unidade_negocio: produto.id_unidade_negocio
          }
        }
      }
    },
    methods: {
      limpaProdutoEdicao () {
        this.$emit('limpaProdutoEdicao')
      },
      resetForm () {
        this.form_data = {
          id_cadastro: null,
          id_produto: null,
          codigo_produto: null,
          nome_produto: null,
          id_flavor: null,
          id_empresa_newcon: null,
          id_modalidade: null,
          id_unidade_negocio: null
        }

        if (this.$refs.formProduto) {
          this.$refs.formProduto.reset()
        }

        this.limpaProdutoEdicao()
      },
      async sendProduto () {
        if (!this.$refs.formProduto.validate()) {
          return
        }

        const formData = new FormData()
        if (this.form_data.id_cadastro) {
          formData.append('id_cadastro', parseInt(this.form_data.id_cadastro))
        }
        formData.append('id_produto', this.form_data.id_produto)
        formData.append('codigo_produto', this.form_data.codigo_produto)
        formData.append('nome_produto', this.form_data.nome_produto)
        if (this.form_data.id_flavor) {
          formData.append('id_flavor', parseInt(this.form_data.id_flavor))
        }
        formData.append('id_empresa_newcon', this.form_data.id_empresa_newcon)
        formData.append('id_modalidade', this.form_data.id_modalidade)
        formData.append('id_unidade_negocio', this.form_data.id_unidade_negocio)

        await this.$http
          .post('/painel/cadastro/produtos', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
          })
          .then((response) => {
            if (response.data.ok === false && response.data.data.requires_confirmation) {
              this.produtosExistentes = response.data.data.produtosExistentes
              this.showConfirmationAlert()
            } else {
              notification(
                AlertTypes.SUCCESS,
                `${this.produtoEdicao ? 'Produto atualizado' : 'Novo produto cadastrado'} com sucesso!`
              )
              this.$emit('registroInserido')
              this.resetForm()
            }
          })
          .catch((err) => {
            const error_message = get(err, 'response.data.Msg_Erro', null)
            if (error_message) {
              notification(
                AlertTypes.ERROR,
                `Erro ao ${this.produtoEdicao ? 'atualizar' : 'cadastrar'} o produto: ${error_message}`
              )
            } else {
              notification(
                AlertTypes.ERROR,
                `Erro ao ${this.produtoEdicao ? 'atualizar' : 'cadastrar'} o produto. Tente novamente.`
              )
            }
          })
      },
      showConfirmationAlert () {
        alert({
          text: 'Um produto com o mesmo ID Produto e Código já existe e está com a modalidade diferente. Se você confirmar, a modalidade dele será atualizada. Deseja continuar?',
          buttons: {
            Cancelar: () => true,
            Confirmar: () => {
              this.confirmUpdate()
            }
          }
        })
      },
      async confirmUpdate () {
        const formData = new FormData()
        if (this.form_data.id_cadastro) {
          formData.append('id_cadastro', parseInt(this.form_data.id_cadastro))
        }

        formData.append('id_produto', this.form_data.id_produto)
        formData.append('codigo_produto', this.form_data.codigo_produto)
        formData.append('nome_produto', this.form_data.nome_produto)
        if (this.form_data.id_flavor) {
          formData.append('id_flavor', parseInt(this.form_data.id_flavor))
        }
        formData.append('id_empresa_newcon', this.form_data.id_empresa_newcon)
        formData.append('id_modalidade', this.form_data.id_modalidade)
        formData.append('id_unidade_negocio', this.form_data.id_unidade_negocio)

        formData.append('produtosExistentes', JSON.stringify(this.produtosExistentes))
        formData.append('confirmacao', true)

        await this.$http
          .post('/painel/cadastro/produtos', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
          })
          .then((response) => {
            notification(AlertTypes.SUCCESS, 'Modalidade atualizada com sucesso!')
            this.$emit('registroInserido')
            this.resetForm()
          })
          .catch((err) => {
            const error_message = get(err, 'response.data.Msg_Erro', null)
            if (error_message) {
              notification(AlertTypes.ERROR, `Erro ao atualizar a modalidade: ${error_message}`)
            } else {
              notification(AlertTypes.ERROR, 'Erro ao atualizar a modalidade. Tente novamente.')
            }
          })
      }
    }
  }
</script>
